module.exports = [
    {
        path: '/expense/index',
        name: 'expense.index',
        component: require('../views/expense/index.vue').default
    }
];

